import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { useGlobalContext } from '@/context/GlobalContext';
import { ArrowUpRight } from 'lucide-react';

// import { useGlobalContext } from "@/src/context/GlobalContext";
// import { RightArrowBlackIcon } from "@/src/Asset";

const CourseLevel = ({ streamData, courseId }: any) => {
  const { setIsLeadFormOpen, setLeadFormData } = useGlobalContext();

  const handleOpen = (title: string, item: any) => {
    const courseData: any = [
      {
        id: item?.id,
        abbreviation: item?.abbreviation,
        course_name: item?.course_name,
      },
    ];
    setLeadFormData({
      source: `coursePage`,
      title: title ?? null,
      course: courseData ?? null,
    });
    setIsLeadFormOpen(true);
    console.log('open lead form');
  };

  return (
    <div className="mx-auto mt-5 px-3 lg:w-4/5 lg:max-w-screen-xl lg:px-0">
      {streamData?.some(
        (stream: any) =>
          stream?.courses?.some((course: any) => course?.page_data?.length > 0) ?? stream?.specializations?.length > 0,
      ) ? (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {streamData
            ?.filter(
              (stream: any) =>
                stream?.courses?.some((course: any) => course?.page_data?.length > 0) ??
                stream?.specializations?.length > 0,
            )
            ?.map((stream: any) => {
              return (
                <div
                  key={stream?.id}
                  className="flex min-h-48 flex-col gap-y-2 rounded-lg border bg-white shadow-xl lg:min-h-60"
                >
                  <div className="flex items-center justify-between gap-x-2 rounded-t-lg bg-gray-100 px-4">
                    <div className="flex items-center gap-x-3 py-2">
                      {stream?.icon?.url && (
                        <Image
                          src={stream?.icon?.url}
                          alt={stream.stream_name ?? 'default stream'}
                          className="size-9"
                          width={200}
                          height={200}
                        />
                      )}
                      <h3 className="text-sm font-semibold tracking-tighter">{stream?.stream_name}</h3>
                    </div>
                    <button className="mb-3 flex items-center self-end rounded border border-black px-2 text-xs tracking-tighter hover:scale-105">
                      <Link href={`/courses/${stream?.stream_name?.toLowerCase()?.replace(/\s+/g, '-')}-${courseId}`}>
                        View courses 
                      </Link>
                      <ArrowUpRight size={12} className='inline-block'/>
                    </button>
                  </div>
                  <div>
                    {stream.courses?.length > 0 ? (
                      <div className="flex flex-col">
                        {stream.courses
                          ?.filter((course: any) => course?.page_data?.length > 0)
                          ?.slice(0, 5)
                          ?.map((course: any) => {
                            const courseNavbar = course?.course_navbars;
                            return (
                              <div key={course?.id} className="mb-2 px-4 font-sans text-sm font-medium">
                                <div className="border-b pb-1.5">
                                  <div className="flex items-center justify-between">
                                    <Link
                                      href={`/courses/${course?.course_url}/${courseNavbar?.[0]?.title
                                        .replace(/\s+/g, '-')
                                        .toLowerCase()}`}
                                      className="text-black "
                                    >
                                      <p className="line-clamp-1">{course?.abbreviation}</p>
                                    </Link>
                                    <button
                                      className="rounded border bg-primary px-2 py-1.5 text-xxs font-normal leading-3 text-white hover:shadow-lg"
                                      onClick={() => handleOpen(course?.abbreviation, course)}
                                    >
                                      Apply Now
                                    </button>
                                  </div>
                                  <div className="pt-1">
                                    {courseNavbar?.length > 0 && (
                                      <div className="inline-flex h-fit gap-x-1.5 text-xs ">
                                        {courseNavbar
                                          ?.slice(0, 3)
                                          ?.sort((a: any, b: any) => a.id - b.id)
                                          ?.map((navbar: any, index: number) => (
                                            <div
                                              key={navbar?.id}
                                              className={`flex items-center ${
                                                index !== 2 ? 'border-r border-gray-300 pr-2' : ''
                                              }`}
                                            >
                                              <Link
                                                href={`/courses/${course?.course_url}/${navbar?.title
                                                  ?.replace(/\s+/g, '-')
                                                  ?.toLowerCase()}`}
                                              >
                                                <p className="font-medium text-primary hover:underline">
                                                  {navbar?.title}
                                                </p>
                                              </Link>
                                            </div>
                                          ))}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    ) : (
                      <p className="px-4">No courses available for this stream.</p>
                    )}
                  </div>
                </div>
              );
            })}
        </div>
      ) : (
        <p className="flex min-h-40 items-center justify-center text-center font-medium text-gray-500">
          No available Streams and courses linked for this page.
        </p>
      )}
    </div>
  );
};

export default CourseLevel;
